export default __webpack_public_path__ + "media/zurb/img/contact/contact1-67cbfb336064a01347ad7f7ce06a5a2d.png";